import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getExpandedSchedulePreviews = api(async function getExpandedSchedulePreviews({ projectId, scheduleIds }) {
    if (!projectId || !scheduleIds?.length) return null

    return query(
        gql`
            query GetExpandedSchedulePreviews($projectId: String!, $scheduleIds: [String!]!) {
                getExpandedSchedulePreviews(projectId: $projectId, scheduleIds: $scheduleIds) {
                    scheduleId
                    schedule {
                        _id
                        id
                        version
                        code
                        title
                        intro {
                            content
                            note
                        }
                        tasks {
                            id
                            isHeader
                            title
                            classification
                            content
                            note
                            taskId
                            componentRef
                            linkedFields
                            frequency {
                                period
                                interval
                            }
                            skillSet
                            minutes
                            unitOfMeasure
                        }
                        legislation
                    }
                    errors {
                        type
                        tokens
                    }
                }
            }
        `,
        { projectId, scheduleIds },
        {
            returns: "getExpandedSchedulePreviews",
            fetchPolicy: "network-only",
        }
    )
})
